
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/environment-variables",
      function () {
        return require("private-next-pages/settings/environment-variables.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/environment-variables"])
      });
    }
  